import { Select, SelectItem } from "@heroui/react";
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '~/locales';

interface ReviewLanguageSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export default function ReviewLanguageSelector({ value, onChange }: ReviewLanguageSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 text-sm text-foreground-500">
      <Select
        selectedKeys={[value]}
        onChange={(e) => onChange(e.target.value)}
        size="sm"
        className="w-full"
        label={t('review.writingIn')}
      >
        {Object.values(LANGUAGES).map((lang) => (
          <SelectItem key={lang.language}>
            {lang.title}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}